/* Statut du dossier chez Sibelga (étape « Encodé Sibelga ») : plusieurs choix possibles. */
import { Check } from 'lucide-react';
import type { SibelgaStatus } from './types';
import { SIBELGA_STATUS_LABELS, SIBELGA_STATUS_ORDER } from './types';

const TONES: Record<SibelgaStatus, { on: string; tag: string }> = {
  submitted: { on: 'border-blue-300 bg-blue-50 text-blue-800', tag: 'bg-blue-50 text-blue-700' },
  meter_replacement: { on: 'border-orange-300 bg-orange-50 text-orange-800', tag: 'bg-orange-100 text-orange-700' },
  contract_mismatch: { on: 'border-red-300 bg-red-50 text-red-800', tag: 'bg-red-50 text-red-700' },
};

/** Cases à cocher (une ou plusieurs). */
export function SibelgaStatusPicker({ value, onChange, disabled }: {
  value: SibelgaStatus[];
  onChange: (next: SibelgaStatus[]) => void;
  disabled?: boolean;
}) {
  const toggle = (s: SibelgaStatus) =>
    onChange(value.includes(s) ? value.filter(v => v !== s) : SIBELGA_STATUS_ORDER.filter(v => v === s || value.includes(v)));
  return (
    <div className="flex flex-wrap gap-1.5">
      {SIBELGA_STATUS_ORDER.map(s => {
        const on = value.includes(s);
        return (
          <button key={s} type="button" onClick={() => toggle(s)} disabled={disabled} aria-pressed={on}
            className={`flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] font-semibold border transition-colors disabled:opacity-50 ${on ? TONES[s].on : 'border-neutral-200 text-neutral-500 hover:border-neutral-300'}`}>
            {on && <Check className="w-3 h-3" />}{SIBELGA_STATUS_LABELS[s]}
          </button>
        );
      })}
    </div>
  );
}

/** Étiquettes affichées sur la carte du pipeline. */
export function SibelgaStatusTags({ value }: { value: SibelgaStatus[] }) {
  if (value.length === 0) return null;
  return (
    <>
      {SIBELGA_STATUS_ORDER.filter(s => value.includes(s)).map(s => (
        <span key={s} className={`text-[10px] font-medium px-1.5 py-0.5 rounded-full ${TONES[s].tag}`}>{SIBELGA_STATUS_LABELS[s]}</span>
      ))}
    </>
  );
}
